import { action } from 'satcheljs';
/**
 * This action has been called inside saveWeatherOption.ts
 * which is used by calendar to attach a middleware ie. orchestrator
 * to run weatherPull task in calendar
 */
var initiateWeatherPullTaskOnCalendar = action('initiateWeatherPullTaskOnCalendar');
export default initiateWeatherPullTaskOnCalendar;
//# sourceMappingURL=initiateWeatherPullTaskOnCalendar.js.map